export default class Ajax {
  static setHeaders = (xhr, headers) => {
    Object.keys(headers).forEach(header => xhr.setRequestHeader(header, headers[header]));
  };

  static extendWithConfig = (xhr, config) => {
    Object.assign(xhr, config);
  };

  constructor({ baseURL = '', transformResponse }) {
    this.baseURL = baseURL;
    this.transformResponse = transformResponse || (response => response);
  }

  request(method, route, payload, headers = {}, config = {}) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.open(method, this.baseURL + route, true);

      Ajax.setHeaders(xhr, headers);
      Ajax.extendWithConfig(xhr, config);

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status >= 200 && xhr.status <= 299) {
            if (typeof xhr.response === 'string') {
              try {
                resolve(this.transformResponse(JSON.parse(xhr.response)));
              } catch (err) {
                reject(err);
              }
            } else {
              resolve(JSON.parse(JSON.stringify(xhr.response)));
            }
          } else {
            reject(xhr);
          }
        }
      };

      xhr.onerror = err => reject(err);

      if (!payload) {
        xhr.send(null);
      } else if (payload instanceof FormData) {
        xhr.send(payload);
      } else {
        xhr.send(JSON.stringify(payload));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/Ajax.js